module.exports = __webpack_public_path__ + "img/telefono.078d2756.svg";